export enum AgoraOptimizationModes {
    Motion = "motion",
    Detail = "detail"
}
